import React from 'react'
import { 
  FormControl, 
  FormControlLabel, 
  FormLabel, 
  Grid, 
  Radio, 
  RadioGroup
} from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import ValidatedDatePicker from '../../compartidos/ValidatedDatePicker';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";
import moment from 'moment';

export const AutorizacionesConfirmacionLaboratorio = ({esUrgente, setEsUrgente, fechaPrescripcion, setFechaPrescripcion}) => {
  return (
    <Grid container justify="center" alignItems="center">
      <Grid
        item
        xs={12} md={4}
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "1.5rem",
        }}
      >
        <FormControl>
          <FormLabel style={{ fontSize: "1.2rem" }}>Urgente:</FormLabel>
          <RadioGroup
            value={esUrgente}
            onChange={(e) => setEsUrgente(e.target.value)}
          >
            <FormControlLabel
              value="esUrgente"
              control={<Radio  />}
              label="Si"
            />
            <FormControlLabel
              value="noEsUrgente"
              control={<Radio />}
              label="No"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
          <ValidatedDatePicker
            fullWidth={true}
            margin="normal"
            format="dd/MM/yyyy"
            okLabel="Aceptar"
            clearLabel="Limpiar"
            cancelLabel="Cancelar"
            label="Fecha Prescripción"
            name="fechaPrescripcion"
            style={{ marginLeft: 15, paddingRight: 30 }}
            value={
              fechaPrescripcion !== undefined &&
                moment(fechaPrescripcion).isValid()
                ? moment(fechaPrescripcion)
                : null
            }
            onChange={(e) => {      
              setFechaPrescripcion(e);
            }}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            maxDate={new Date()}
            validators={
              [
                "required",
              ]
            }
            errorMessages={              
              [
                "La fecha de prescripción es requerida",
              ]
            }
          />
        </MuiPickersUtilsProvider>
      </Grid>
    </Grid>
  )
}
